/**
 * ハプティックフィードバック（触覚）ユーティリティ
 *
 * - Android: navigator.vibrate()
 * - iOS 17.4+: <input type="checkbox" switch> の Taptic Engine ハック
 * - その他: no-op（壊れても何も起きない設計）
 */

type HapticKind = "light" | "success" | "error";

const VIBRATE_PATTERNS: Record<HapticKind, number | number[]> = {
  light: 20,
  success: [20, 40, 30],
  error: [30, 40, 30, 40, 30],
};

function triggerIOSSwitchHaptic() {
  if (typeof document === "undefined") return;

  const label = document.createElement("label");
  label.style.cssText =
    "position:fixed;left:-9999px;top:0;opacity:0;pointer-events:none;";

  const input = document.createElement("input");
  input.type = "checkbox";
  input.setAttribute("switch", "");

  label.appendChild(input);
  document.body.appendChild(label);
  label.click();

  setTimeout(() => label.remove(), 100);
}

export function triggerHaptic(kind: HapticKind = "light") {
  if (typeof window === "undefined") return;

  try {
    // Android: Vibration API
    if ("vibrate" in navigator && typeof navigator.vibrate === "function") {
      navigator.vibrate(VIBRATE_PATTERNS[kind]);
      return;
    }

    // iOS: switch checkbox hack (Taptic Engine)
    triggerIOSSwitchHaptic();
  } catch {
    // no-op: ハプティクスが失敗しても業務に影響なし
  }
}
